







import Vue from 'vue'
import PageTitle from '@/components/atoms/PageTitle.vue'
import PointGet from '@/components/molecules/PointGet.vue'

export default Vue.extend({
  name: 'CheckInComplete',
  components: {
    PageTitle,
    PointGet
  },
  computed: {
    point: function() {
      return this.$state.stamps.selected
    }
  },
  methods: {
    handleClick() {
      this.$router.push('/home')
    }
  }
})
